import React from 'react';
import TaxbillContainer from '../../containers/taxIssuedmng/TaxbillContainer';

const TaxIssuedViewPage = () => {
  return <TaxbillContainer />
};

export default TaxIssuedViewPage;
